export default __webpack_public_path__ + "static/media/headerCar.aca0bb83.png";